{
  "en": {
    "labels": {
      "true": "Yes",
      "false": "No",
      "null": "-",
      "supporter": {
        "badge": "Supporter",
        "tooltip": "Supports FleetYards.net this month"
      },
      "destroyedFleets": {
        "discarded": "Discarded",
        "purged": "Purged"
      },
      "and": "and",
      "hide": "Hide",
      "show": "Show",
      "only": "Only",
      "description": "Description",
      "unavailable": "unavailable",
      "selected": "Selected",
      "actions": "Actions",
      "status": "Status",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "collapse": "Collapse",
      "price": "Price",
      "expand": "Expand",
      "distance": "Distance",
      "anonymous": "Anonymous",
      "toggleNavigation": "Toggle Navigation",
      "enableYoutube": "Click to enable Youtube embeds or right click to copy Video URL",
      "openInNewWindow": "Open in fullscreen",
      "or": "or",
      "deselect": "Click to deselect",
      "networkStatusOffline": "Network Status: Offline - Service Unavailable",
      "groups": "Groups",
      "classifications": "Classifications",
      "features": {
        "stateOn": "Enabled",
        "stateOff": "Disabled",
        "stateConditional": "Conditional",
        "selfService": "Self-service",
        "selfServiceEnabled": "Users can toggle this feature",
        "selfServiceDisabled": "Users cannot toggle this feature",
        "actors": "Actors",
        "groups": "Groups",
        "noGroups": "No groups enabled for this feature.",
        "noActors": "No individual actors enabled for this feature.",
        "user": "User",
        "fleet": "Fleet",
        "actorType": "Actor Type",
        "percentageOfActors": "of actors",
        "percentageOfTime": "of time",
        "currentState": "Current State",
        "toggle": "Toggle",
        "settingsIntro": "Enable or disable experimental features for your account. These features may be incomplete or change without notice.",
        "noFeaturesAvailable": "No self-service features are currently available.",
        "descriptions": {
          "tools_travel_times": "Show estimated travel times between locations.",
          "tools_cargo_grids": "Show interactive cargo grid viewer for ships.",
          "fleet_starmap": "Show Star Citizen starmap on fleet member pages."
        },
        "registryHint": "Flags are declared in config/feature_flags.yml and created on deploy. Here you control their gates.",
        "fleetSettingsIntro": "Enable or disable features for the whole fleet. Every member sees what you switch on here.",
        "fleetFeature": "Fleet feature",
        "fleetFeatureInfo": "Switching this on here enables it for you alone. Your fleet's admins can enable it for the whole fleet.",
        "toggleForSelf": "Toggle for yourself only",
        "fleetFeatureGrantedShort": "Enabled by fleet",
        "fleetFeatureGranted": "Your fleet enabled this for all members, so it cannot be switched off here."
      },
      "oauthApplication": {
        "name": "Application Name",
        "clientId": "Client ID",
        "clientSecret": "Client Secret",
        "redirectUri": "Redirect URI",
        "redirectUriHint": "Use one URI per line.",
        "confidential": "Confidential",
        "scopes": "Scopes",
        "scopesHint": "If no scopes are selected, the default scopes will be used: %{scopes}"
      },
      "rsiRequestLogs": {
        "resolved": "Resolved",
        "unresolved": "Unresolved"
      },
      "imports": {
        "type": "Type",
        "status": "Status",
        "version": "Version",
        "startedAt": "Started",
        "finishedAt": "Finished",
        "failedAt": "Failed at",
        "info": "Info",
        "input": "Input",
        "output": "Output",
        "importData": "Import Data",
        "file": "Imported File",
        "requestedBy": "Requested by",
        "adminUser": "Admin User",
        "user": "User",
        "includeSystem": "Include system",
        "systemRequester": "system",
        "statuses": {
          "created": "Queued",
          "started": "Running",
          "finished": "Finished",
          "failed": "Failed"
        }
      },
      "oauthApplications": {
        "settingsIntro": "Manage your OAuth applications. These applications can access the FleetYards API on behalf of users.",
        "name": "Application Name",
        "redirectUri": "Redirect URI",
        "confidential": "Confidential",
        "clientId": "Client ID",
        "clientSecret": "Client Secret",
        "scopes": "Scopes",
        "defaultScopes": "Default scopes",
        "confidentialShort": "Confidential",
        "publicShort": "Public"
      },
      "fleetInviteToken": "Fleet Invite",
      "scDataVersion": "Patch Version",
      "lastReload": "Last Reload",
      "createdAt": "Created at",
      "updatedAt": "Updated at",
      "addToHangar": "Add to Hangar",
      "home": {
        "search": "Search for Ships..."
      },
      "shop": {
        "rentalPrice": "rental",
        "sellPrice": "sells for",
        "buyPrice": "buys for"
      },
      "shopCommodity": {
        "item": "Item",
        "shop": "Shop",
        "sellPrices": "Sell Prices",
        "buyPrices": "Buy Prices",
        "rentalPrices": "Rental Prices",
        "confirmed": "Confirmed?",
        "submittedBy": "Submitted By",
        "prices": {
          "label": "Prices",
          "rentalPrice": "rental",
          "averageRentalPrice": "rental (Ø)",
          "sellPrice": "sells for",
          "averageSellPrice": "sells for (Ø)",
          "buyPrice": "buys for",
          "averageBuyPrice": "buys for (Ø)",
          "rentalPrice1Day": "1 Day for",
          "averageRentalPrice1Day": "1 Day for (Ø)",
          "rentalPrice3Days": "3 Days for",
          "averageRentalPrice3Days": "3 Days for (Ø)",
          "rentalPrice7Days": "7 Days for",
          "averageRentalPrice7Days": "7 Days for (Ø)",
          "rentalPrice30Days": "30 Days for",
          "averageRentalPrice30Days": "30 Days for (Ø)"
        }
      },
      "stats": {
        "quickStats": {
          "newShips": "New Ships in %{year}",
          "totalShips": "Total Ships",
          "totalMembers": "Total Members",
          "vehicles": "Hangared Ships",
          "wishlists": "Wishlisted Ships",
          "shipOfTheMonth": "Ship of the Month"
        },
        "modelsByClassification": "Ships by Classification",
        "modelsBySize": "Ships by Size",
        "vehiclesByModel": "Ships by Model (Top %{limit})",
        "modelsPerMonth": "Ships per Month",
        "modelsByManufacturer": "Ships by Manufacturer",
        "modelsByProductionStatus": "Ships by Production Status",
        "vehiclesPerMonth": "Hangared Ships per Month",
        "topVehiclesByModel": "Top 10 Hangared Ships",
        "shipsOfTheMonth": "Ship of the Month",
        "crewDeficit": "Crew Deficit",
        "crewSurplus": "Crew Surplus",
        "membersByRole": "Members by Role"
      },
      "roadmap": {
        "selectWeek": "Select Week",
        "shipRoadmap": "Ship-Roadmap",
        "releases": "Releases",
        "unscheduled": "Unscheduled",
        "lastUpdate": "Last Update",
        "released": "Released",
        "recentlyUpdated": "Recently Updated",
        "committed": "Committed",
        "lastVersion": {
          "active": {
            "false": "Item was removed from the Roadmap",
            "true": "Item was readded to the Roadmap"
          },
          "committed": "Item was marked as committed",
          "released": "Item was released to PU",
          "release": "Item moved from release %{old} to %{new}",
          "addedToRelease": "Item new in release %{release}"
        },
        "stories": {
          "one": "%{count} Story",
          "other": "%{count} Stories"
        },
        "tasks": {
          "one": "of %{count} Task",
          "other": "of %{count} Tasks"
        },
        "ships": {
          "one": "%{count} Ship",
          "other": "%{count} Ships"
        }
      },
      "rsiRoadmap": "RSI Roadmap",
      "unknown": "Unknown",
      "none": "-",
      "notAvailable": "N/A",
      "unknownModel": "%{slug} Unknown",
      "not-available": "N/A",
      "receiveSaleNotifications": "",
      "publicUrl": "Public URL",
      "name": "Name",
      "homepage": "Homepage",
      "discord": "Discord Server",
      "youtube": "Youtube Channel",
      "twitch": "Twitch Channel",
      "guilded": "Guilded Server",
      "3dView": "3D",
      "3dMap": "Map",
      "filter": "Filter",
      "taxExcluded": "excl. VAT",
      "hangar": "Hangar",
      "public": "Public",
      "hangarStats": "Stats",
      "wishlist": "Wishlist",
      "fleetchart": "Fleetchart",
      "fleetchartApp": {
        "screenHeight": "Screen Height",
        "viewpoint": "Viewpoint",
        "screenHeightOptions": {
          "1x": "1x",
          "1_5x": "1.5x",
          "2x": "2x",
          "3x": "3x",
          "4x": "4x"
        },
        "viewpointOptions": {
          "side": "Side",
          "top": "Top",
          "angled": "Angled",
          "front": "Front"
        },
        "gridSize": "%{size} meter per grid box",
        "mode": "Mode",
        "modeOptions": {
          "classic": "Classic",
          "panzoom": "v2"
        }
      },
      "fleetStats": "Stats",
      "hangarMetrics": {
        "total": "Total",
        "totalMoney": "Pledge Value",
        "totalCredits": "In-Game Bought Value",
        "totalIngameValue": "Hangar aUEC Value",
        "totalMinCrew": "Min. Crew",
        "totalMaxCrew": "Max. Crew",
        "totalCargo": "Total Cargo",
        "largestShip": "Largest Ship",
        "smallestShip": "Smallest Ship",
        "averagePledgePrice": "Avg. Pledge Price",
        "flightReady": "Flight Ready",
        "uniqueModels": "Unique Models",
        "manufacturerCount": "Manufacturers",
        "missingClassifications": "Missing Roles",
        "wishlistTotalMoney": "Wishlist Pledge Value",
        "wishlistTotalCredits": "Wishlist In-Game Value"
      },
      "selectModel": "Select a Ship",
      "findModel": "Type to find a Ship",
      "find": "Type to search",
      "selectUser": "Select a User",
      "findUser": "Type to find a User",
      "selectAdminUser": "Select an Admin User",
      "selectFleet": "Select a Fleet",
      "findFleet": "Type to find a Fleet",
      "compare": {
        "removeModel": "Remove Ship",
        "addModel": {
          "nullablePrompt": "Add a Ship"
        },
        "enough": "Don't you think 8 Ships are enough? ;)",
        "toggleSection": "Toggle %{section}",
        "shipCount": {
          "one": "%{count} Ship",
          "other": "%{count} Ships"
        },
        "containersOfSize": "%{size} SCU Containers",
        "shieldGenerators": "Shield Generators",
        "armorHp": "Armor HP",
        "fuelAndQuantum": "Fuel & Quantum",
        "weaponPoolSize": "Weapon Power Pool",
        "crossSection": {
          "x": "Cross Section X",
          "y": "Cross Section Y",
          "z": "Cross Section Z"
        },
        "useAsBaseline": "Use as baseline",
        "baseline": "Baseline",
        "differencesOnly": "Differences only",
        "compareToBaseline": "Compare to baseline",
        "loadoutBySlot": "Loadout by slot",
        "slots": {
          "guns": "Main guns",
          "turrets": "Turrets",
          "missiles": "Missiles",
          "shields": "Shield generators",
          "powerPlants": "Power plants",
          "coolers": "Coolers",
          "quantumDrives": "Quantum drives",
          "thrusters": "Main thrusters",
          "countermeasures": "Countermeasures"
        },
        "legend": {
          "best": "best in row",
          "worst": "worst",
          "share": "share of the row's best",
          "better": "beats the baseline",
          "worse": "behind it"
        }
      },
      "cargoRoutes": "Cargo routes",
      "uecPerUnit": "aUEC / Unit",
      "au": "AU",
      "uec": "aUEC",
      "sell": "Sell",
      "buy": "Buy",
      "yourFlagship": "Your Flagship",
      "flagship": "Flagship",
      "fleet": {
        "destroyInfo": "If you want to delete this Fleet and remove all its information from Fleetyards.net click the button below. Be aware that this is a permanent action and can't be reverted.",
        "classes": "Fleet",
        "fid": "Fleet ID",
        "name": "Name",
        "logo": "Logo",
        "rsiSid": "SID",
        "description": "Description",
        "public": "Public Fleetview",
        "publicFleet": "Public Fleet",
        "publicStats": "Public Stats",
        "publicFleetStats": "Public Fleet Stats",
        "discord": {
          "url": "Discord Server",
          "hint": "Connect a Discord server to mirror events as native scheduled events. Members can RSVP from Discord and the sign-up will sync back to Fleetyards.",
          "guildId": "Discord Server ID",
          "channelId": "Voice Channel ID (optional)",
          "webhookUrl": "Announcement Webhook URL (optional)",
          "installBotHint": "Opens the Discord install page in a new tab — pick the server you want events mirrored to.",
          "statusOk": "Connected to %{name}",
          "statusCodes": {
            "missing_token": "The Fleetyards bot is not configured on the server side. Contact an administrator.",
            "missing_guild": "Enter a Discord server ID first.",
            "invalid_token": "The bot token is invalid. Contact an administrator.",
            "bot_not_in_guild": "The bot is not in this server. Use the install link to add it.",
            "guild_not_found": "Discord doesn't recognize this server ID. Double-check the value.",
            "discord_error": "Discord returned an unexpected error.",
            "request_failed": "Could not reach Fleetyards. Try again."
          }
        },
        "guilded": "Guilded Server",
        "homepage": "Homepage",
        "twitch": "Twitch Channel",
        "youtube": "Youtube Channel",
        "backgroundImage": "Background Image",
        "ts": "Teamspeak Server",
        "awaitingConfirmation": "Awaiting confirmation by Fleet",
        "members": {
          "primary": "Primary Fleet?",
          "hideShips": "Hide your Ships for this Fleet?",
          "shipsFilter": {
            "label": "Which Ships should be added to the Fleet?",
            "nullablePrompt": "No Option selected",
            "field": "Ships Select",
            "values": {
              "all": "All Ships",
              "hangar_group": "All Ships in a given Hangar Group",
              "hide": "No Ships"
            }
          },
          "hangarGroupId": {
            "field": "Hangar Group",
            "label": "Specify a Hangar Group",
            "nullablePrompt": "No Group selected"
          },
          "total": "Total: %{count}",
          "joined": "Joined at",
          "invited": "Invited",
          "invitedAt": "Invited / Requested at",
          "requested": "Membership Requested",
          "declined": "Declined",
          "pending": "Pending Invites & Requests",
          "accepted": "Members",
          "declinedMembers": "Declined",
          "role": "Role",
          "roles": {
            "admin": "Admin",
            "officer": "Officer",
            "member": "Member"
          },
          "contact": "Contact",
          "spectrumDm": "Message on Spectrum",
          "discordContact": "Discord"
        },
        "roles": {
          "permanent": "Permanent",
          "privilegeGroups": {
            "fleet": "Fleet",
            "memberships": "Members",
            "invites": "Invites",
            "vehicles": "Vehicles",
            "roles": "Roles",
            "inventories": "Inventories",
            "missions": "Missions",
            "events": "Events",
            "notifications": "Notifications"
          },
          "privileges": {
            "fleet:update": "Update Fleet",
            "fleet:update:images": "Update Images",
            "fleet:update:description": "Update Description",
            "fleet:delete": "Delete Fleet",
            "fleet:manage": "Manage Fleet",
            "fleet:memberships:read": "View Members",
            "fleet:memberships:create": "Invite Members",
            "fleet:memberships:update": "Update Members",
            "fleet:memberships:delete": "Remove Members",
            "fleet:memberships:manage": "Manage Members",
            "fleet:invites:read": "View Invites",
            "fleet:invites:create": "Create Invites",
            "fleet:invites:delete": "Delete Invites",
            "fleet:invites:manage": "Manage Invites",
            "fleet:vehicles:read": "View Vehicles",
            "fleet:vehicles:create": "Add Vehicles",
            "fleet:vehicles:update": "Update Vehicles",
            "fleet:vehicles:delete": "Remove Vehicles",
            "fleet:vehicles:manage": "Manage Vehicles",
            "fleet:roles:read": "View Roles",
            "fleet:roles:create": "Create Roles",
            "fleet:roles:update": "Update Roles",
            "fleet:roles:delete": "Delete Roles",
            "fleet:roles:manage": "Manage Roles",
            "fleet:inventories:read": "View Inventories",
            "fleet:inventories:create": "Create Inventories",
            "fleet:inventories:update": "Update Inventories",
            "fleet:inventories:delete": "Delete Inventories",
            "fleet:inventories:manage": "Manage Inventories",
            "fleet:missions:read": "View Missions",
            "fleet:missions:create": "Create Missions",
            "fleet:missions:update": "Update Missions",
            "fleet:missions:delete": "Delete Missions",
            "fleet:missions:manage": "Manage Missions",
            "fleet:events:read": "View Events",
            "fleet:events:create": "Create Events",
            "fleet:events:update": "Update Events",
            "fleet:events:delete": "Delete Events",
            "fleet:events:manage": "Manage Events",
            "fleet:notifications:manage": "Manage Notification Settings"
          }
        },
        "inviteUrls": {
          "noLimit": "No limit",
          "noExpiration": "Never expires",
          "usesLeft": "%{count} uses left",
          "used": "Used %{count} times",
          "usedOfLimit": "Used %{count} of %{limit}",
          "expiresIn": "Expires in %{time}",
          "expired": "Expired",
          "expiresAfterOptions": {
            "infinite": "Never",
            "30_minutes": "30 minutes",
            "1_hour": "1 hour",
            "6_hours": "6 hours",
            "12_hours": "12 hours",
            "1_day": "1 day",
            "7_days": "7 days"
          },
          "limitOptions": {
            "infinite": "No limit",
            "1": "1 use",
            "5": "5 uses",
            "10": "10 uses",
            "25": "25 uses",
            "50": "50 uses",
            "100": "100 uses"
          }
        },
        "calendarSubscription": {
          "intro": "Generate a private link that members can use to subscribe to this fleet's events from their calendar app (Apple Calendar, Google Calendar, Outlook).",
          "howTo": "Share the link above with your members. They paste it into their calendar app (\"Subscribe to calendar\" or \"Add by URL\"). The link is private — anyone with it can see this fleet's events."
        },
        "notifications": {
          "inAppHeading": "In-app Notifications",
          "inAppHint": "Pick which event lifecycle changes show up as in-app notifications for fleet members.",
          "events": {
            "fleet_event": {
              "published": "Event published",
              "locked": "Sign-ups locked",
              "unlocked": "Sign-ups reopened",
              "starting_soon": "Event starting soon",
              "started": "Event started",
              "completed": "Event completed",
              "cancelled": "Event cancelled",
              "archived": "Event archived",
              "destroyed": "Event deleted"
            },
            "fleet_event_signup": {
              "created": "Signup added",
              "withdrawn": "Signup withdrawn"
            }
          }
        }
      },
      "hangarGroup": {
        "name": "Name",
        "color": "Color",
        "sort": "Sort Order",
        "public": "Show on Public Hangar?"
      },
      "source": "Source",
      "loadout": {
        "namePlaceholder": "Loadout name...",
        "urlPlaceholder": "Paste erkul.games or spviewer.eu loadout URL...",
        "empty": "No loadouts yet. Create one to get started.",
        "active": "Active",
        "activate": "Set Active",
        "planOn": "Plan your loadout on"
      },
      "model": {
        "hidden": "Hidden?",
        "active": "Active?",
        "inGame": "In Game?",
        "adiMap": "ADI Map?",
        "ground": "Ground Vehicle?",
        "productionNote": "Production Note",
        "rsiId": "RSI ID",
        "length": "Length",
        "beam": "Beam",
        "height": "Height",
        "scKey": "SC Key",
        "price": "Price",
        "pledgePrice": "Pledge Price",
        "erkulIdentifier": "Erkul Identifier",
        "mass": "Mass",
        "minCrew": "Min. Crew",
        "maxCrew": "Max. Crew",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "Max Speed",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "cargo": "Cargo",
        "cargoHolds": "Cargo Holds",
        "hydrogenFuelTankSize": "Hydrogen Fuel Tank Size",
        "hydrogenFuelTanks": "Hydrogen Fuel Tanks",
        "quantumFuelTankSize": "Quantum Fuel Tank Size",
        "quantumFuelTanks": "Quantum Fuel Tanks",
        "externalFuelTanks": "External Fuel Tanks",
        "externalFuelTanksTotal": "Total Capacity",
        "externalFuelTanksCount": "Pods",
        "refuelBoom": "Refueling Boom",
        "refuelBoomArm": "Arm",
        "refuelBoomNozzle": "Nozzle",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "Yaw Boosted",
        "pitchBoosted": "Pitch Boosted",
        "rollBoosted": "Roll Boosted",
        "variants": "Variants",
        "manufacturer": "Manufacturer",
        "loaners": "Loaners",
        "paints": "Paints",
        "modules": "Modules",
        "modulePackages": "Module Packages",
        "upgrades": "Upgrade-Kits",
        "brochure": "Brochure",
        "holo": "Holo",
        "angledView": "Angled View",
        "angledViewColored": "Angled View Colored",
        "sideView": "Side View",
        "sideViewColored": "Side View Colored",
        "frontView": "Front View",
        "frontViewColored": "Front View Colored",
        "topView": "Top View",
        "topViewColored": "Top View Colored",
        "onSale": "On Sale",
        "playerOwnable": "Player Ownable?",
        "salesPage": "Sales Page",
        "addons": "Modules & Upgrade-Kits",
        "storeImage": "Store Image",
        "wiki": "Star Citizen Wiki",
        "crewPositions": "Crew Positions",
        "needsCuration": "Needs Curation",
        "curatedPosition": "Manually curated position",
        "baseModel": "Base Model",
        "fleetchartOffsetLength": "Fleetchart Offset Length",
        "fleetchartOffsetBeam": "Fleetchart Offset Beam",
        "extendedLength": "Extended Length",
        "extendedBeam": "Extended Beam",
        "extendedHeight": "Extended Height",
        "extendedFleetchartOffsetLength": "Extended Fleetchart Offset Length",
        "extendedFleetchartOffsetBeam": "Extended Fleetchart Offset Beam",
        "defaultHolo": "Default Holo",
        "extendedHolo": "Extended Holo",
        "extendedTopView": "Extended Top View",
        "extendedTopViewColored": "Extended Top View Colored",
        "extendedSideView": "Extended Side View",
        "extendedSideViewColored": "Extended Side View Colored",
        "extendedFrontView": "Extended Front View",
        "extendedFrontViewColored": "Extended Front View Colored",
        "extendedAngledView": "Extended Angled View",
        "extendedAngledViewColored": "Extended Angled View Colored",
        "state": {
          "retracted": "Retracted",
          "extended": "Extended"
        },
        "productionStatus": {
          "in-production": "In Production",
          "in-concept": "In Concept",
          "ready": "Hangar Ready",
          "flight-ready": "Flight Ready",
          "announced": "Announced"
        }
      },
      "models": {
        "extraColumns": "Columns",
        "table": {
          "columns": {
            "storeImage": "Image",
            "storeImageWide": "Wide Image",
            "rsiStoreImage": "RSI Image",
            "rsiStoreImageWide": "Wide RSI Image",
            "angledView": "3D Image",
            "angledViewWide": "Wide 3D Image",
            "rsiId": "RSI ID",
            "hidden": "Hidden",
            "active": "Active",
            "createdAt": "Created At",
            "updatedAt": "Updated At",
            "manufacturerName": "Manufacturer",
            "length": "Length",
            "beam": "Beam",
            "height": "Height",
            "mass": "Mass",
            "cargo": "Cargo",
            "quantumFuelTankSize": "Quantum Fuel",
            "hydrogenFuelTankSize": "Hydrogen Fuel",
            "minCrew": "Crew",
            "maxCrew": "Max. Crew",
            "scmSpeed": "SCM Speed",
            "maxSpeed": "Max Speed",
            "groundMaxSpeed": "Ground Speed",
            "focus": "Focus",
            "productionStatus": "Production Status",
            "price": "Price",
            "pledgePrice": "Pledge Price"
          }
        }
      },
      "metrics": {
        "info": "Info",
        "levels": "Levels",
        "views": "Views",
        "base": "Base",
        "crew": "Crew",
        "speed": "Speed",
        "cargo": "Cargo",
        "combat": "Combat",
        "hardpoints": "Hardpoints",
        "missileOptions": "Missle Options (if available)"
      },
      "flight": {
        "title": "Flight",
        "scm": "combat cruise",
        "nav": "cruise",
        "boost": "Boost",
        "boostSub": "afterburner",
        "reverse": "Reverse",
        "maneuverability": "Maneuverability",
        "fuel": "Fuel",
        "fuelHydrogen": "Hydrogen",
        "fuelQuantum": "Quantum",
        "hint": "Boosted handling scales with the engine pips; all zero when the engine is unpowered."
      },
      "base": {
        "price": "Price",
        "priceInGame": "In-game",
        "pricePledge": "Pledge",
        "availability": "Availability"
      },
      "availability": {
        "title": "Availability",
        "buy": "Buy",
        "rent": "Rent",
        "cheapest": {
          "buy": "Cheapest buy",
          "rent": "Cheapest rent"
        },
        "locations": {
          "one": "%{count} location",
          "other": "%{count} locations"
        },
        "empty": "No known buy or rental locations.",
        "timeRange": {
          "1-day": "1 day",
          "3-days": "3 days",
          "7-days": "7 days",
          "30-days": "30 days"
        }
      },
      "cargo": {
        "title": "Cargo",
        "holdsSub": "across %{count} holds",
        "maxContainerSub": "largest box that fits",
        "containers": "Container Capacity",
        "hint": "Maximum number of containers of each size that fit the cargo grids; the bar shows how much of the total capacity that fills."
      },
      "fuelTanks": {
        "capacitySub": "across %{count} pods",
        "podsSub": "external mounts",
        "components": "Pod Types",
        "perPod": "per pod",
        "hint": "Fuel carried in pods mounted on external hardpoints; the bar shows each type's share of the total capacity."
      },
      "refuelBoom": {
        "fuelFlowSub": "hydrogen transfer",
        "quantumFlowSub": "quantum transfer",
        "captureRadiusSub": "docking tolerance",
        "equipment": "Equipment",
        "hint": "Transfer rates of the refueling arm and the docking tolerance of its nozzle."
      },
      "combat": {
        "title": "Combat",
        "dps": "Burst DPS",
        "dpsSub": "%{count} weapons",
        "sustained": "Sustained DPS",
        "sustainedSub": "with regen & heat",
        "alpha": "Alpha",
        "alphaSub": "per volley",
        "weapons": "Weapons",
        "missileDamage": "Missile Damage",
        "composition": "Damage Composition",
        "damagePhysical": "Physical",
        "damageEnergy": "Energy",
        "damageDistortion": "Distortion",
        "damageThermal": "Thermal",
        "hint": "DPS from the default loadout. Sustained factors in each weapon's energy-pool regen and overheat cycle. Missiles excluded."
      },
      "power": {
        "title": "Power Distribution",
        "scm": "SCM",
        "nav": "NAV",
        "reset": "Reset",
        "auto": "Auto",
        "aimAssist": "Aim Assist",
        "cooling": "Cooling",
        "ir": "IR",
        "em": "EM",
        "cs": "CS",
        "csAxisHint": "Click to switch axis (x / y / z)",
        "segmentsUsed": "%{used} / %{total} segments",
        "hint": "Move power between systems. Weapons' sustained DPS scales with the power they get; the rest is auto-balanced.",
        "families": {
          "weapon": "Weapons",
          "shield": "Shields",
          "engine": "Engine",
          "radar": "Radar",
          "coolers": "Coolers",
          "qdrive": "Quantum Drive",
          "qed": "QED",
          "emp": "EMP",
          "lifeSupport": "Life Support",
          "miningLaser": "Mining Laser",
          "salvage": "Salvage",
          "tractorBeam": "Tractor Beam",
          "towingbeam": "Towing Beam"
        }
      },
      "defense": {
        "title": "Defense",
        "shieldHp": "Shield HP",
        "shieldHpSub": "%{count} generators",
        "shieldRegen": "Regeneration",
        "shieldResistances": "Resistance",
        "shieldAbsorption": "Absorption",
        "armor": "Armor",
        "deflection": "Deflection",
        "armorReduction": "Damage reduction",
        "armorSelfResistance": "Self resistance",
        "armorSignature": "Signature",
        "damageType": {
          "physical": "Phys",
          "energy": "Energy",
          "distortion": "Distort",
          "thermal": "Thermal"
        },
        "signature": {
          "electromagnetic": "EM",
          "infrared": "IR",
          "crossSection": "CS"
        },
        "hint": "Shield and armor values from the default loadout. Absorption below 100% means that damage type reaches the hull while the shields are still up.",
        "openDeflectionCheck": "Deflection check"
      },
      "deflectionCheck": {
        "title": "Deflection Check",
        "intro": "— which guns pierce its defenses?",
        "noArmor": "This ship carries no armor, so nothing is deflected.",
        "allSizes": "All",
        "deflected": "deflected",
        "pierce": "pierce",
        "weapon": "Weapon",
        "boundary": "Deflection boundary",
        "alpha": "Alpha",
        "threshold": "Threshold crossed",
        "absorbed": "absorbed",
        "versus": "vs",
        "hoverHint": "Hover a weapon for the per-type breakdown.",
        "note": "Alpha is compared per pellet, after the shield's soak — a gun pierces when it beats the deflection on any damage type. Types the shields absorb completely never reach the armor, so they are listed as absorbed rather than deflected: stopped by the shield, not the hull. Shield absorption interpolates across its published min–max range by shield health, and armor deflection scales linearly with armor health. Laser beams are excluded — they deal continuous damage, so there is no per-shot alpha to test.",
        "margin": "Margin",
        "reachesArmor": "Reaches armor",
        "stoppedByShields": "Shield absorbs",
        "verdict": {
          "absorbed": "Absorbed",
          "deflected": "Deflected",
          "pierces": "Pierced"
        },
        "shieldHealth": "Shield health",
        "armorHealth": "Armor health",
        "absorb": "Absorb",
        "defl": "Defl",
        "type": "Type",
        "size": "Size"
      },
      "hull": {
        "category": {
          "vital": "Vital",
          "secondary": "Secondary",
          "breakable": "Breakable",
          "subpart": "Subparts",
          "cosmetic": "Cosmetic"
        },
        "composition": "Hull Composition",
        "door": "Door",
        "doors": "Doors",
        "doorsNote": "Breakable interior doors are a separate area — they carry their own health and are not part of hull HP.",
        "doorsSub": "%{count} breakable",
        "hint": "Hull HP is the sum of all part health.",
        "hullHp": "Hull HP",
        "hullHpSub": "total across all parts",
        "integrity": "Hull Integrity",
        "noHp": "no HP",
        "parts": "Hull Parts",
        "partsNote": "Parts are ranked by health; cosmetic parts (doors, ladders, flaps) carry no health of their own. The game files expose no parent/child links, so this is a flat list rather than a structural tree.",
        "partsSub": "across %{count} categories",
        "partsTree": "Parts · damageMax",
        "showParts": "Show hull parts",
        "title": "Hull",
        "totalHp": "Total Hull HP"
      },
      "manufacturer": {
        "longName": "Long Name",
        "code": "Code",
        "logo": "Logo",
        "scRef": "SC Ref"
      },
      "fundingGoal": {
        "title": "Title",
        "description": "Description",
        "amount": "Amount",
        "currency": "Currency",
        "effectiveFrom": "Effective from",
        "endedAt": "Ended at"
      },
      "supporterContribution": {
        "name": "Supporter Name",
        "user": "Linked Account",
        "amount": "Amount",
        "currency": "Currency",
        "anonymous": "Anonymous",
        "recurring": "Recurring",
        "startedAt": "Started at",
        "endedAt": "Ended at",
        "note": "Internal note",
        "stats": {
          "total": "Total",
          "count": "Contributions",
          "currentMonth": "This Month",
          "currentMonthCount": "%{count} contributions",
          "recurringCount": "Recurring",
          "anonymousCount": "Anonymous"
        },
        "chart": {
          "contributions": "Contributions",
          "goal": "Goal"
        }
      },
      "itemPrice": {
        "price": "Price",
        "location": "Location",
        "locationUrl": "Location URL"
      },
      "video": {
        "url": "URL",
        "videoType": "Type"
      },
      "modelModule": {
        "name": "Name",
        "description": "Description",
        "price": "Price",
        "pledgePrice": "Pledge Price",
        "productionStatus": "Production Status",
        "scKey": "SC Key",
        "storeImage": "Store Image",
        "active": "Active?",
        "hidden": "Hidden?"
      },
      "dock": {
        "name": "Name",
        "dockType": "Dock Type",
        "shipSize": "Ship Size"
      },
      "modelPosition": {
        "name": "Name",
        "positionType": "Position Type",
        "source": "Source",
        "position": "Sort Order",
        "types": {
          "pilot": "Pilot",
          "copilot": "Co-pilot",
          "turret_gunner": "Turret gunner",
          "engineer": "Engineer",
          "gunner": "Gunner",
          "loadmaster": "Loadmaster",
          "passenger": "Passenger",
          "operator": "Operator",
          "custom": "Custom"
        }
      },
      "modelHardpoint": {
        "name": "Name",
        "key": "Key",
        "source": "Source",
        "group": "Group",
        "hardpointType": "Type",
        "size": "Size",
        "category": "Category",
        "subCategory": "Sub Category",
        "details": "Details",
        "mount": "Mount",
        "itemSlots": "Item Slots",
        "loadoutIdentifier": "Loadout Identifier"
      },
      "modelHardpointLoadout": {
        "name": "Name"
      },
      "modelUpgrade": {
        "name": "Name",
        "description": "Description",
        "pledgePrice": "Pledge Price",
        "active": "Active?",
        "hidden": "Hidden?"
      },
      "modelModulePackage": {
        "name": "Name",
        "description": "Description",
        "pledgePrice": "Pledge Price",
        "modules": "Modules",
        "active": "Active?",
        "hidden": "Hidden?"
      },
      "cargoHold": {
        "offsetX": "Offset X (SCU)",
        "offsetY": "Offset Y (SCU)",
        "offsetZ": "Offset Z (SCU)",
        "rotation": "Rotation (°)"
      },
      "modelLoaner": {
        "hidden": "Hidden?",
        "loanerModel": "Loaner Model"
      },
      "modelSnubCraft": {
        "snubCraft": "Snub Craft"
      },
      "modelPaint": {
        "hidden": "Hidden?",
        "active": "Active?",
        "onSale": "On Sale",
        "pledgePrice": "Pledge Price",
        "productionStatus": "Production Status",
        "productionNote": "Production Note",
        "copyHint": "Select the target ship to copy this paint to. The paint data is not modified during the copy.",
        "bulkCopyHint": "Select the target ship to copy these %{count} paints to. The paint data is not modified during the copy.",
        "copySameModel": "Target ship must differ from the source ship."
      },
      "component": {
        "size": "Size: %{size}",
        "grade": "Grade",
        "hidden": "Hidden?",
        "componentClass": "Component Class",
        "componentType": "Component Type",
        "componentSubType": "Component Sub Type",
        "itemType": "Item Type",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "hardpoint": {
        "legend": {
          "headline": "Legend",
          "slotTaken": "Slot taken",
          "slotAvailable": "Slot available"
        },
        "size": "Size",
        "rackSize": "Rack Size",
        "details": "Details",
        "group": "Group",
        "thrusters": {
          "thrust": "Thrust",
          "subTypes": {
            "JointThruster": "Joint",
            "FixedThruster": "Fix",
            "FlexThruster": "Flex",
            "Retro": "Fix"
          }
        },
        "refuelBoom": {
          "captureRadius": "Capture Radius",
          "fuelFlowRate": "Fuel Flow Rate",
          "quantumFuelFlowRate": "Quantum Fuel Flow Rate"
        },
        "weapons": {
          "dps": "DPS",
          "burstDps": "Burst DPS",
          "sustainedDps": "Sustained DPS",
          "efficiency": "Efficiency",
          "penetration": "Penetration",
          "fireRate": "Fire Rate",
          "speed": "Speed",
          "range": "Range",
          "ammo": "Ammo",
          "ammoCost": "Ammo Cost",
          "pool": "Energy Pool",
          "maxRegen": "Max Regen/s",
          "costPerShot": "Energy/Shot",
          "heatPerShot": "Heat/Shot",
          "heatPerSecond": "Heat/s",
          "chargeTime": "Charge Time",
          "fullDamageRange": "Full DMG Range",
          "zeroDamageRange": "Zero DMG Range",
          "damagePhysical": "Physical",
          "damageEnergy": "Energy",
          "damageDistortion": "Distortion",
          "damageThermal": "Thermal"
        },
        "missiles": {
          "damage": "Damage",
          "speed": "Speed",
          "range": "Range",
          "lockRange": "Lock Range",
          "lockTime": "Lock Time",
          "trackingSignal": "Tracking"
        },
        "tractorBeams": {
          "maxForce": "Max Force",
          "minForce": "Min Force",
          "range": "Range",
          "cone": "Cone",
          "tetherBreak": "Tether Break",
          "cargoForce": "Cargo Force",
          "cargoRange": "Cargo Range",
          "towForce": "Tow Force",
          "towDistance": "Tow Range",
          "quantumTowMass": "QT Mass Limit",
          "rotationSpeed": "Rotation",
          "moveSpeed": "Move Speed"
        },
        "shields": {
          "hp": "HP",
          "regen": "Regen",
          "regenTime": "Regen Time",
          "downedRegenDelay": "Downed Delay",
          "damagedRegenDelay": "Damaged Delay",
          "resistancePhysical": "Phys. Resist.",
          "resistanceEnergy": "Energy Resist.",
          "resistanceDistortion": "Dist. Resist."
        },
        "coolers": {
          "coolingRate": "Cooling Rate"
        },
        "powerPlants": {
          "output": "Output",
          "pips": "Pips"
        },
        "quantumDrives": {
          "speed": "Speed",
          "range": "Range",
          "fuelConsumption": "Consumption",
          "spoolUpTime": "Spool Up",
          "cooldownTime": "Cooldown",
          "splineSpeed": "Orbit",
          "accel": "Accel"
        },
        "jumpDrives": {
          "fuelEfficiency": "Fuel Efficiency",
          "alignRate": "Align Rate",
          "tuneRate": "Tune Rate",
          "alignDecay": "Align Decay",
          "tuneDecay": "Tune Decay"
        },
        "radar": {
          "aimAssistRange": "Assist Range",
          "ir": "IR",
          "em": "EM",
          "cs": "CS",
          "rs": "RS"
        },
        "armor": {
          "hp": "HP",
          "physical": "Physical",
          "energy": "Energy",
          "distortion": "Distortion",
          "thermal": "Thermal",
          "deflectPhysical": "Phys Deflect",
          "deflectEnergy": "Energy Deflect",
          "selfPhysical": "Self-Res Phys",
          "selfEnergy": "Self-Res Energy"
        },
        "fuelIntakes": {
          "pushRate": "Push Rate",
          "minRate": "Min Rate"
        },
        "sources": {
          "game_files": "Game Files",
          "ship_matrix": "Ship Matrix"
        },
        "density": {
          "title": "View",
          "compact": "Compact",
          "expanded": "Expanded"
        },
        "fuelTanks": {
          "hydrogen": "Hydrogen Fuel Tank",
          "quantum": "Quantum Fuel Tank"
        },
        "jumpDrive": "Jump Drive",
        "maxContainerSize": "Max. Container Size",
        "groups": {
          "avionic": "Avionics",
          "system": "Systems",
          "propulsion": "Propulsion",
          "thruster": "Thruster",
          "weapon": "Weapons",
          "defense": "Defense",
          "other": "Other",
          "auxiliary": "Auxiliary",
          "seat": "Seats",
          "external_fuel_tank": "External Fuel Tanks",
          "refuel_boom": "Refuel Boom"
        },
        "types": {
          "radar": "Radar",
          "computers": "Computers",
          "power_plants": "Power Plants",
          "coolers": "Coolers",
          "shield_generators": "Shield Generators",
          "fuel_intakes": "Fuel Intakes",
          "fuel_tanks": "Fuel Tanks",
          "quantum_drives": "Quantum Drives",
          "jump_modules": "Jump Modules",
          "jumpdrive": "Jump Modules",
          "quantum_fuel_tanks": "Quantum Fuel Tanks",
          "main_thrusters": "Main Thrusters",
          "maneuvering_thrusters": "Maneuvering Thrusters",
          "weapons": "Weapons",
          "turrets": "Turrets",
          "missiles": "Missiles",
          "utility_items": "Utility Items",
          "utility": "Utility Items",
          "emp": "EMP",
          "qed": "QED"
        },
        "moduleSlotEmpty": "— Select Module —",
        "selectModule": "Select Module",
        "clearModule": "Clear Selection",
        "categories": {
          "radar": "Radar",
          "armor": "Armor",
          "relay": "Relay",
          "countermeasures": "Countermeasures",
          "lifesupport": "Life Support",
          "selfdestruct": "Self Destruct",
          "batteries": "Batteries",
          "computers": "Computers",
          "powerplant": "Power Plants",
          "cooler": "Coolers",
          "module": "Modules",
          "shieldgenerator": "Shield Generators",
          "fuel_intakes": "Fuel Intakes",
          "fueltanks": "Fuel Tanks",
          "external_fuel_tanks": "External Fuel Tanks",
          "refuel_boom": "Refuel Boom",
          "quantumdrive": "Quantum Drives & Jump Modules",
          "jump_modules": "Jump Modules",
          "jumpdrive": "Jump Modules",
          "quantum_fuel_tanks": "Quantum Fuel Tanks",
          "main_thrusters": "Main Thrusters",
          "maneuvering_thrusters": "Maneuvering Thrusters",
          "retro_thrusters": "Retro Thrusters",
          "vtol_thrusters": "VTOL Thrusters",
          "weapons": "Weapons",
          "weapon_mounts": "Weapon Mounts",
          "turret": "Turrets",
          "missiles": "Missiles",
          "missile_racks": "Missile Racks",
          "utility_items": "Utility Items",
          "utility": "Utility Items",
          "emp": "EMP",
          "quantumenforcementdevice": "QED",
          "salvagefillerstation": "Salvage Filler Station",
          "cargogrid": "Cargo Grid",
          "seat": "Seats"
        }
      },
      "blank": {
        "propulsion": "No Propulsion present",
        "ordnance": "No Ordnance present",
        "modular": "No Modular present",
        "avionics": "No Avionics present",
        "fleetInvites": "No Invites present",
        "shopCommodities": "No Commodites available",
        "userShips": "Your Hangar is currently Empty. To Add Ships / Vehicles to Your Hangar click the following Icon on Any Ship in the Database:"
      },
      "user": {
        "rsiHandle": "Handle",
        "rsiHandleVerified": "Verified via Citizen iD",
        "location": "Location",
        "currentSystem": "Current Star System",
        "tester": "Tester?",
        "avatar": "Avatar",
        "unconfirmedEmail": "Unconfirmed email",
        "saleNotify": "I want to receive Sale Notifications",
        "publicHangar": "Public Hangar enabled",
        "publicHangarLoaners": "Show Loaners Hint on Public Hangar",
        "publicHangarStats": "Public Hangar Stats enabled",
        "publicWishlist": "Public Wishlist enabled",
        "hideOwner": "Hide Ownership for Fleets",
        "tracking": "Allow anonymous usage analytics",
        "lastActiveAt": "Last Active",
        "confirmedAt": "Confirmed at",
        "dateFormat": "Date format",
        "dateFormats": {
          "dmy_dots": "31.12.2026",
          "dmy_slash": "31/12/2026",
          "mdy_slash": "12/31/2026",
          "ymd_dash": "2026-12-31"
        }
      },
      "adminUser": {
        "superAdmin": "Super Admin",
        "passwordConfirmation": "Password Confirmation"
      },
      "vehicle": {
        "name": "Name",
        "states": "States",
        "serial": "Serial",
        "owner": "commanded by",
        "flagship": "Flagship",
        "wanted": "Wanted",
        "loaner": "Loaner",
        "bundled": "Bundled",
        "bundledWith": "Bundled with %{parent}",
        "public": "Public Visible",
        "fullPublic": "Public Visible including Name",
        "publicShort": "Public",
        "nameVisible": "Public Visible",
        "saleNotify": "I want to receive Sale Notifications",
        "hangarGroups": "Groups",
        "selectGroup": "Select a Group",
        "modelPaintSelect": {
          "nullablePrompt": "Select a Paint",
          "label": "Paint"
        },
        "bulkGroupEdit": {
          "hint": "Existing Groups will be overridden!"
        },
        "hasLoaners": "Loaners",
        "boughtViaSelect": {
          "label": "Bought via"
        }
      },
      "image": {
        "active": "Active?",
        "background": "Use as Background?",
        "caption": "Caption",
        "enabled": "Enabled?",
        "file": "Image File",
        "global": "Global?",
        "delete": "Delete",
        "start": "Start",
        "cancel": "Cancel",
        "processing": "Processing...",
        "error": "Error",
        "name": "Name",
        "size": "File size",
        "dropzone": "Drop images here",
        "cancelUpload": "Cancel upload",
        "startUpload": "Start upload",
        "selectImages": "Add images...",
        "selectFolder": "Add a folder..."
      },
      "signup": {
        "link": "Don't have an Account?",
        "privacyPolicy": "By creating a FleetYards account, you agree to our"
      },
      "privacyPolicy": "Privacy Policy",
      "login": "Username or email",
      "username": "Username",
      "twoFactorCode": "Two-factor code",
      "confirmationCode": "Confirmation code",
      "email": "Email",
      "avatar": "Avatar",
      "alreadyRegistered": "Already have an Account?",
      "currentPassword": "Current Password",
      "password": "Password",
      "passwordConfirmation": "Password Confirmation",
      "rememberMe": "Remember me",
      "emptyList": "No %{name} present",
      "all": "All",
      "supportUs": "Support FleetYards.net",
      "account": {
        "destroyInfo": "If you want to delete Your Account and remove all your Information from Fleetyards.net and its Services click the Button below. Be aware of that this is a permanent Action and can't be reverted.",
        "calendarSubscription": {
          "intro": "Generate a private link to add the events you've signed up for to your personal calendar app (Apple Calendar, Google Calendar, Outlook).",
          "howTo": "Paste the link into your calendar app under \"Subscribe to calendar\" or \"Add by URL\". Anyone with this link can see the events you're signed up for — keep it private."
        }
      },
      "filters": {
        "components": {
          "name": "Name",
          "itemType": "Item Type",
          "componentClass": "Component Class",
          "buyPriceGt": "Buy Price >=",
          "buyPriceLt": "Buy Price <=",
          "sellPriceGt": "Sell Price >=",
          "sellPriceLt": "Sell Price <=",
          "storeImageBlank": "Without Store Image?"
        },
        "shops": {
          "name": "Name",
          "type": "Type",
          "celestialObject": "Celestial object",
          "model": "Ship",
          "equipment": "Equipment",
          "component": "Component",
          "commodity": "Commodity",
          "commodityType": "Commodity Type",
          "starsystem": "Starsystem",
          "station": "Station"
        },
        "shopCommodities": {
          "commodityType": "Commodity Type",
          "station": "Station",
          "shopId": "Shop",
          "equipment": "Equipment",
          "component": "Component",
          "componentItemTypeFilter": "Component Item Types",
          "equipmentItemTypeFilter": "Equipment Item Types",
          "equipmentTypeFilter": "Equipment Type",
          "equipmentSlotFilter": "Equipment Slot",
          "commodity": "Commodity",
          "model": "Ship",
          "name": "Name"
        },
        "shopItems": {
          "category": "Category",
          "subCategory": "Sub Category",
          "name": "Name",
          "manufacturer": "Manufacturer",
          "minPrice": "min. Price",
          "maxPrice": "max. Price"
        },
        "stations": {
          "name": "Name",
          "celestialObject": "Celestial Object",
          "starsystem": "Starsystem",
          "type": "Station Type",
          "shops": "Shops",
          "docks": "Docks",
          "habs": "Habitation?",
          "cargoHub": "Cargo Hub?",
          "refinery": "Refinery Station?"
        },
        "vehicles": {
          "name": "Name or Ship name",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "Price <=",
          "priceGt": "Price >=",
          "wanted": "Wanted",
          "hidden": "Hidden",
          "public": "Public",
          "group": "Group",
          "loaner": "Loaners",
          "bundled": "Bundled Snub Crafts",
          "boughtVia": "Bought via?"
        },
        "tradeRoutes": {
          "sortBy": "Sort by",
          "sortByValues": {
            "percent": "Max. Percent",
            "profit": "Max. Profit"
          },
          "cargoShip": "With Cargoship?",
          "origin": "From?",
          "destination": "To?",
          "excludeCommodityType": "Exclude Commodity Type",
          "originCelestialObject": "Origin Celestial Object",
          "destinationCelestialObject": "Destination Celestial Object",
          "originStarsystem": "Origin Starsystem",
          "destinationStarsystem": "Destination Starsystem"
        },
        "models": {
          "name": "Name",
          "shipRole": "Ship Role",
          "classification": "Classification",
          "focus": "Focus",
          "manufacturer": "Manufacturer",
          "onSale": "On Sale",
          "size": "Size",
          "dockSize": "Dock Size",
          "price": "Price",
          "pledgePrice": "Pledge Price",
          "productionStatus": "Production Status",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "beamLt": "Beam <=",
          "beamGt": "Beam >=",
          "heightLt": "Height <=",
          "heightGt": "Height >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "Price <=",
          "priceGt": "Price >=",
          "willItFit": "Will it Fit?",
          "withCargo": "With Cargo?",
          "scKeyBlank": "Without SC Key?",
          "positionsNeedCuration": "Positions Need Curation?",
          "fleetchartImageBlank": "Without Fleetchart Image?",
          "holoBlank": "Without Holo?",
          "frontViewBlank": "Without Front View Image?",
          "topViewColoredBlank": "Without Top View Colored Image?"
        },
        "modelModules": {
          "name": "Name"
        },
        "manufacturers": {
          "name": "Name",
          "withModels": "With Models",
          "logoBlank": "Without Logo"
        },
        "supporterContributions": {
          "name": "Search by name",
          "recurring": "Recurring",
          "anonymous": "Anonymous",
          "startedAtGteq": "Started from",
          "startedAtLteq": "Started until",
          "user": "Linked account",
          "linked": "Account link",
          "linkedOnly": "Linked",
          "unlinkedOnly": "Not linked"
        },
        "adminNotifications": {
          "search": "Search"
        },
        "images": {
          "station": "Station",
          "model": "Ship"
        },
        "users": {
          "search": "Search",
          "username": "Username",
          "email": "Email",
          "rsiHandle": "RSI Handle"
        },
        "fleets": {
          "name": "Name",
          "fid": "FID",
          "member": "Member",
          "members": {
            "role": "Role",
            "state": "Status",
            "acceptedAtGt": "Joined from",
            "acceptedAtLt": "Joined until",
            "invitedAtGt": "Invited from",
            "invitedAtLt": "Invited until",
            "requestedAtGt": "Requested from",
            "requestedAtLt": "Requested until",
            "declinedAtGt": "Declined from",
            "declinedAtLt": "Declined until"
          },
          "inviteUrls": {
            "expiresAfter": "Expire after",
            "limit": "Max number of uses"
          },
          "logistics": {
            "search": "Search items..."
          }
        },
        "manufacturer": "Manufacturer",
        "commodities": {
          "name": "Name",
          "commodityType": "Commodity Type",
          "uexCode": "UEX Code",
          "buyPriceGt": "Buy Price >=",
          "buyPriceLt": "Buy Price <=",
          "sellPriceGt": "Sell Price >=",
          "sellPriceLt": "Sell Price <=",
          "storeImageBlank": "Without Store Image?"
        },
        "equipment": {
          "name": "Name",
          "equipmentType": "Equipment Type",
          "itemType": "Item Type",
          "weaponClass": "Weapon Class",
          "slot": "Slot",
          "buyPriceGt": "Buy Price >=",
          "buyPriceLt": "Buy Price <=",
          "sellPriceGt": "Sell Price >=",
          "sellPriceLt": "Sell Price <=",
          "storeImageBlank": "Without Store Image?"
        }
      },
      "station": {
        "docks": "Docks",
        "location": "Location",
        "type": "Type",
        "habitation": "Habitation",
        "habs": "Habs",
        "shops": "Shops",
        "locationPrefix": {
          "default": "on",
          "asteriod": "on asteroid near",
          "orbit": "in orbit around"
        },
        "locationSuffix": "near %{location}"
      },
      "tradeRoutes": {
        "buy": "Buy for: %{uec}",
        "sell": "Sell for: %{uec}",
        "cargoShip": "for %{cargo} SCU",
        "sortByPercent": "Sort by Percent",
        "sortByProfit": "Sort by Profit",
        "sortByStation": "Sort by Station",
        "showAveragePrices": "Display average Prices",
        "showLatestPrices": "Display latest Prices"
      },
      "hardpoints": {
        "prefix": "Tryout Loadouts with",
        "erkul": "Erkul's DPS Calculator",
        "spviewer": "SP Viewer",
        "spviewerTitle": "SC Ships Performances Viewer",
        "metricsCredit": "Metrics based on the formulas of"
      },
      "scunpacked": {
        "prefix": "Loadouts based on Gamefiles powered by",
        "link": "SCunpacked"
      },
      "newVehicle": {
        "nullablePrompt": "Select a Ship"
      },
      "addAddon": {
        "nullablePrompt": ""
      },
      "table": {
        "selected": "%{count} Selected"
      },
      "commodityPrice": {
        "shopId": "Shop",
        "station": "Station",
        "commodityItemType": "Commodity Type",
        "commodityItemId": "Commodity Item",
        "item": "ShopCommodity",
        "price": "Price",
        "type": "Type",
        "shop": "Shop",
        "submittedBy": "Submitted By"
      },
      "syncExtension": {
        "warnings": "Warnings",
        "status": {
          "started": "Import Started...",
          "finished": "Import Finished",
          "failed": "Import Failed!"
        },
        "processSteps": {
          "fetchHangar": "Fetching Data from the RSI Hangar",
          "submitData": "Submitting Data to the Fleetyards.net Backend"
        },
        "sessionStatus": "RSI Session status",
        "checkIdentity": "Check RSI Session",
        "identityStatus": {
          "pending": "Checking...",
          "notFound": "not found",
          "connected": "connected"
        },
        "platforms": {
          "chrome": "Google Chrome or Chromium based Browsers",
          "firefox": "Mozilla Firefox",
          "edge": "Microsoft Edge",
          "opera": "Opera",
          "github": "GitHub"
        },
        "pledgeItems": {
          "pages": "Pages",
          "all": "All Pledge Items",
          "ships": "Ships",
          "components": "Modules",
          "skins": "Paints",
          "upgrades": "Upgrades"
        },
        "importedItems": {
          "importedVehicles": "Added Ships",
          "foundVehicles": "Found Ships",
          "movedVehiclesToWanted": "Moved Ships to Wishlist",
          "missingModels": "Ships not found",
          "importedComponents": "Added Components",
          "foundComponents": "Found Components",
          "missingComponents": "Components not found",
          "missingComponentVehicles": "No matching Ship found for Components",
          "importedUpgrades": "Added Upgrades",
          "foundUpgrades": "Found Upgrades",
          "missingUpgrades": "Upgrades not found",
          "missingUpgradeVehicles": "No matching Ship found for Upgrades"
        }
      },
      "cargoGridViewer": {
        "capacity": "Capacity",
        "maxContainerSize": "Max. Container",
        "packed": "Packed",
        "totalCargo": "Total Cargo",
        "didNotFit": "Did not fit",
        "openInTool": "Open in Cargo Grid Tool",
        "myHangar": "Show only my Ships",
        "filterShips": "Filter Ships by Container Size",
        "addShip": "Add Ship",
        "removeShip": "Remove",
        "autoFillShip": "Auto-fill"
      },
      "admin": {
        "dashboard": {
          "quickStats": {
            "onlineUsers": "Online Users",
            "totalUsers": "Total Users",
            "totalShips": "Total Ships",
            "newShipsInYear": "New Ships in %{year}",
            "totalFleets": "Total Fleets"
          }
        },
        "modelHardpoint": {
          "loadouts": "Loadouts"
        },
        "supporterContributions": {
          "source": {
            "patreon": "Patreon",
            "manual": "Manual"
          }
        }
      },
      "hangarTable": {
        "extraColumns": "Columns",
        "columns": {
          "storeImage": "Image",
          "storeImageWide": "Wide Image",
          "angledView": "3D Image",
          "angledViewWide": "Wide 3D Image",
          "modelManufacturerName": "Manufacturer",
          "modelLength": "Length",
          "modelBeam": "Beam",
          "modelHeight": "Height",
          "modelMass": "Mass",
          "modelCargo": "Cargo",
          "modelMinCrew": "Crew",
          "modelMaxCrew": "Max. Crew",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Max Speed",
          "modelGroundMaxSpeed": "Ground Speed",
          "modelFocus": "Focus",
          "modelProductionStatus": "Production Status",
          "modelPrice": "Price",
          "modelPledgePrice": "Pledge Price"
        }
      },
      "fleetTable": {
        "extraColumns": "Columns",
        "columns": {
          "storeImage": "Image",
          "storeImageWide": "Wide Image",
          "angledView": "3D Image",
          "angledViewWide": "Wide 3D Image",
          "modelManufacturerName": "Manufacturer",
          "modelLength": "Length",
          "modelBeam": "Beam",
          "modelHeight": "Height",
          "modelMass": "Mass",
          "modelCargo": "Cargo",
          "modelMinCrew": "Crew",
          "modelMaxCrew": "Max. Crew",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Max Speed",
          "modelGroundMaxSpeed": "Ground Speed",
          "modelProductionStatus": "Production Status",
          "modelPrice": "Price",
          "modelPledgePrice": "Pledge Price",
          "owner": "Owner"
        }
      },
      "logistics": {
        "inventoryCount": "inventories",
        "pending": "pending",
        "inProgress": "in progress",
        "drafts": "drafts",
        "noInventories": "No inventories yet.",
        "noRequests": "No requests found.",
        "noItems": "No entries in this inventory.",
        "entriesCount": "entries",
        "comments": "comments",
        "managedBy": "Managed by",
        "itemName": "Name",
        "category": "Category",
        "component": "Component",
        "componentCategory": "Component Type",
        "commodity": "Commodity",
        "commodityType": "Commodity Type",
        "equipment": "Equipment",
        "equipmentItemType": "Equipment Type",
        "quantity": "Quantity",
        "unit": "Unit",
        "notes": "Notes",
        "status": "Status",
        "requested": "Requested",
        "fulfilled": "Fulfilled",
        "itemFulfilled": "Fulfilled",
        "itemPending": "Pending",
        "requestTitle": "Title",
        "description": "Description",
        "requestType": "Type",
        "priority": "Priority",
        "requestedBy": "Requested by",
        "approvedBy": "Approved by",
        "fulfilledBy": "Fulfilled by",
        "addComment": "Write a comment...",
        "states": {
          "draft": "Draft",
          "submitted": "Submitted",
          "approved": "Approved",
          "in_progress": "In Progress",
          "fulfilled": "Fulfilled",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "requestTypes": {
          "supply": "Supply",
          "outfitting": "Outfitting",
          "general": "General"
        },
        "priorities": {
          "routine": "Routine",
          "standard": "Standard",
          "urgent": "Urgent",
          "critical": "Critical"
        },
        "searchInventories": "Search inventories...",
        "searchItems": "Search items...",
        "quality": "Quality (0-1000)",
        "qualityShort": "Quality",
        "qualityMin": "Quality >=",
        "qualityMax": "Quality <=",
        "existingItem": "Select existing item",
        "inventoryName": "Inventory Name",
        "visibility": "Visibility",
        "visibilities": {
          "members_only": "All Members",
          "officers_only": "Officers Only"
        },
        "inventory": "Inventory",
        "notesPlaceholder": "Add notes...",
        "entryType": "Type",
        "entryTypes": {
          "deposit": "Deposit",
          "withdrawal": "Withdrawal"
        },
        "stockView": "Current Stock",
        "logView": "Transaction Log",
        "addedBy": "Logged by",
        "member": "Member",
        "selectItem": "Select item",
        "currentStock": "Available",
        "location": "Location",
        "image": "Image",
        "categories": {
          "commodity": "Commodity",
          "component": "Component",
          "weapon": "Weapon",
          "equipment": "Equipment",
          "ammunition": "Attachments & Ammunition",
          "consumable": "Consumable",
          "other": "Other"
        },
        "units": {
          "scu": "SCU",
          "units": "Units"
        },
        "csvImportHelp": "Upload a CSV file with columns: name, category, quantity, unit, notes. Download the template for the correct format.",
        "imported": "items imported",
        "importErrors": "errors",
        "inStock": "In stock",
        "entries": "Entries",
        "lastEntry": "Last entry",
        "history": "History",
        "linkedItem": "Linked item",
        "itemUnavailable": "Not in current patch",
        "itemUnavailableHint": "The current game build no longer ships this item. Entries keep it, but it cannot be picked for new ones.",
        "qualityRange": "Quality",
        "stockItem": "Stock Item",
        "overCapacity": "over cargo capacity",
        "cargoGrid": "Cargo Grid",
        "shipInventory": "Ship Inventory",
        "remaining": "Remaining",
        "unmeasured": "%{count} not measured yet"
      },
      "hangarInventories": "Inventories",
      "adminNotifications": {
        "unreadOnly": "Unread only",
        "status": "Status",
        "severity": "Severity",
        "type": "Type",
        "severities": {
          "info": "Info",
          "warning": "Warning",
          "error": "Error"
        },
        "types": {
          "paints_import": "Paints Import",
          "modules_import": "Modules Import",
          "loaner_sync": "Loaner Sync",
          "uex_prices_import": "UEX Price Sync",
          "uex_commodity_prices_import": "UEX Commodity Sync",
          "new_supporter": "New Supporter",
          "rsi_api_blocked": "RSI API Blocked",
          "rsi_api_unblocked": "RSI API Restored",
          "weekly_stats": "Weekly Report"
        }
      },
      "optional": "optional",
      "notificationTypes": {
        "channels": {
          "app": "App",
          "mail": "Mail",
          "push": "Push"
        },
        "groups": {
          "account": "Account & hangar",
          "fleetMembership": "Fleet membership",
          "fleetEvents": "Fleet events"
        },
        "hangar_create": "Hangar created",
        "hangar_destroy": "Hangar removed",
        "hangar_sync_finished": "Hangar sync finished",
        "hangar_sync_failed": "Hangar sync failed",
        "wishlist_create": "Added to wishlist",
        "wishlist_destroy": "Removed from wishlist",
        "model_on_sale": "Model on sale",
        "new_model": "New model released",
        "fleet_invite": "Fleet invite received",
        "fleet_member_requested": "Membership requested",
        "fleet_member_accepted": "Membership accepted",
        "fleet_request_accepted": "Join request accepted",
        "fleet_inventory_item_added": "Fleet inventory item added",
        "fleet_event_published": "Event published",
        "fleet_event_locked": "Event sign-ups locked",
        "fleet_event_starting_soon": "Event starting soon",
        "fleet_event_started": "Event started",
        "fleet_event_completed": "Event completed",
        "fleet_event_cancelled": "Event cancelled",
        "fleet_event_signup_added": "New signup",
        "fleet_event_signup_withdrawn": "Signup withdrawn",
        "fleet_event_signup_confirmed": "Signup confirmed",
        "fleet_event_signup_assigned": "Assigned to a slot",
        "fleet_event_signup_kicked": "Removed from a slot"
      },
      "fleets": {
        "missions": {
          "title": "Title",
          "description": "Description",
          "team": "Team",
          "teams": "Teams",
          "ship": "Ship",
          "ships": "Ships",
          "slot": "Slot",
          "slots": "Slots",
          "noMissions": "No missions yet.",
          "noTeams": "No teams added yet.",
          "noShips": "No ships added yet.",
          "noSlots": "No slots added yet.",
          "archivedTab": "Archived",
          "activeTab": "Active",
          "archived": "Archived",
          "modelSpecific": "Specific Ship",
          "modelList": "Any of these",
          "modelListHint": "The spot takes any one of the ships you pick.",
          "allowedShips": "Ships that fit",
          "anyOf": "Any of",
          "filterRange": "Filter Range",
          "classification": "Classification",
          "focus": "Focus",
          "minSize": "Min Size",
          "maxSize": "Max Size",
          "minCrew": "Min Crew",
          "minCrewOverride": "Override",
          "minCrewOverrideLabel": "Min Crew Override",
          "minCrewOverrideHint": "Leave empty to use the ship's default min crew.",
          "minCargo": "Min Cargo (SCU)",
          "shipFilters": "Ship Filters",
          "createdBy": "Created by",
          "seats": "Seats",
          "category": "Category",
          "coverImage": "Cover Image",
          "coverPresets": "Pick from examples",
          "scenario": "Scenario",
          "categories": {
            "other": "Other",
            "ship_combat": "Ship Combat",
            "ground_combat": "Ground Combat",
            "combined_combat": "Combined Combat",
            "mining": "Mining",
            "salvage": "Salvage",
            "cargo_hauling": "Cargo Hauling",
            "exploration": "Exploration"
          }
        },
        "events": {
          "title": "Title",
          "description": "Description",
          "briefing": "Briefing",
          "startsAt": "Starts at",
          "endsAt": "Ends at",
          "timezone": "Timezone",
          "location": "Event location",
          "meetupLocation": "Meetup location",
          "visibility": "Visibility",
          "maxAttendees": "Max attendees",
          "maxAttendeesValue": "Max %{count} attendees",
          "autoLockEnabled": "Auto-lock signups",
          "autoLockMinutesBefore": "Lock minutes before start",
          "recurring": "Repeats",
          "recurringHint": "Generate this event automatically on a recurring schedule. Members sign up per occurrence.",
          "recurringSummary": "Repeats %{interval}",
          "recurringUntil": "Repeats %{interval} until %{date}",
          "recurringForCount": "Repeats %{interval} (%{count} occurrences)",
          "viewSeries": "View series",
          "recurrenceInterval": "Repeat every",
          "recurrenceEnd": "Ends",
          "recurrenceEndNever": "Never",
          "recurrenceEndOn": "On date",
          "recurrenceEndAfter": "After",
          "recurrenceEndOccurrences": "occurrences",
          "recurrence": {
            "daily": "daily",
            "weekly": "weekly",
            "biweekly": "every two weeks",
            "monthly": "monthly"
          },
          "occurrencesSection": "Upcoming occurrences",
          "skipOccurrence": "Skip this occurrence",
          "overrideOccurrence": "Override occurrence on %{date}",
          "overrideOccurrenceShort": "Edit this one",
          "overrideOccurrenceHint": "Override fields for this single occurrence. Leave blank to inherit from the recurring event.",
          "endSeriesHere": "Stop here and going forward",
          "excludedBadge": "Skipped",
          "noUpcomingOccurrences": "No upcoming occurrences in the next 12 weeks.",
          "endSeriesConfirm": "Stop the recurrence after this date? Future occurrences won't be generated.",
          "skipOccurrenceSuccess": "Occurrence skipped.",
          "endSeriesSuccess": "Series ended from this date forward.",
          "cancelledReason": "Cancellation reason",
          "noEvents": "No events yet.",
          "noUpcoming": "No upcoming events.",
          "noPast": "No past events.",
          "createdBy": "Created by",
          "signups": "Signups",
          "signupsCount": "%{count} signups",
          "signupYou": "You",
          "youAreHere": "You're here",
          "attendance": "Attendance",
          "signupsLockedHint": "Sign-ups are locked for this event.",
          "noOverview": "No description or briefing yet.",
          "alreadySignedUpHint": "You're already signed up to a different slot. Withdraw first to switch.",
          "slotTakenHint": "This slot is already taken.",
          "currentSlot": "Current slot",
          "currentSlotHint": "This is the slot the signup is currently in.",
          "takenBy": "Taken by %{username}",
          "slotPickerHint": "Pick a slot for this signup. Slots that are already taken or unavailable are disabled.",
          "signupCtaHint": "Sign up to the event — you can pick a specific slot now or let an admin assign you later.",
          "noSlotYet": "No slot yet",
          "signupApproval": "Signup approval",
          "signupApprovalInherit": "Inherit from event",
          "signupStatuses": {
            "confirmed": "Confirmed",
            "tentative": "Tentative",
            "interested": "Interested",
            "pending": "Pending approval",
            "withdrawn": "Withdrawn"
          },
          "signupApprovals": {
            "direct": "Direct",
            "confirmation_required": "Needs confirmation"
          },
          "unassignedSignupsHint": "These members signed up to the event but don't have a slot yet. Assign them below or remove the signup.",
          "taken": "Taken",
          "grantedRoles": "Granted roles",
          "noEventAdminsYet": "No additional admins or moderators yet.",
          "creator": "Event creator",
          "eventTeamHint": "Grant other members admin or moderator rights for this event. Admins can edit it, moderators can manage signups.",
          "eventRole": "Role",
          "eventRoles": {
            "admin": "Admin",
            "moderator": "Moderator"
          },
          "memberPicker": "Member",
          "spawnedFromMission": "Spawned from mission",
          "spawnedEvents": "Spawned events",
          "fromMission": "From mission",
          "pickTemplate": "Pick a template",
          "pickTemplateHint": "Optionally start from a mission template — fields will be pre-filled and the event will be linked back.",
          "noTemplate": "No template",
          "noTemplateHint": "Build the event from scratch.",
          "changeTemplate": "Change template",
          "clearTemplate": "Clear template",
          "freeSlot": "Open slot",
          "myVehicle": "My vehicle",
          "selectVehicle": "Select a vehicle (optional)",
          "vehicleMismatchHint": "The selected vehicle doesn't match this slot's requirements.",
          "noFittingInHangar": "Nothing in your hangar fits this slot. You can still sign up by leaving the vehicle empty.",
          "vehicleFitsHint": "Bringing a vehicle that fits this ship.",
          "noMatchingVehicle": "No signup brings a fitting vehicle.",
          "shipNotCrewedYet": "No fitting signup yet.",
          "expandHint": "%{model} has %{count} more seat(s). Add slots so others can fill them?",
          "notes": "Notes",
          "upcomingTab": "Upcoming",
          "pastTab": "Past",
          "archivedTab": "Archived",
          "listTab": "List",
          "calendarTab": "Calendar",
          "openInCalendar": "Subscribe (.ics)",
          "openInCalendarHint": "Add this URL to your calendar app to keep events in sync.",
          "rotateFeedToken": "Rotate feed link",
          "subscribeHint": "Copies the calendar feed URL to your clipboard so you can paste it into your calendar app.",
          "visibilities": {
            "members": "Members",
            "officers": "Officers",
            "fleet": "Public"
          },
          "statuses": {
            "draft": "Draft",
            "open": "Open for sign-ups",
            "locked": "Sign-ups locked",
            "active": "Live",
            "completed": "Completed",
            "cancelled": "Cancelled",
            "past": "Past"
          },
          "tabs": {
            "basic": "Basic info",
            "description": "Description & cover",
            "teams": "Teams & ships",
            "overview": "Overview",
            "settings": "Settings"
          },
          "calendar": {
            "month": "Month",
            "week": "Week",
            "weekTitle": "Week of %{date}"
          },
          "repeats": "Repeats"
        }
      },
      "commodity": {
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "equipment": {
        "equipmentType": "Equipment Type",
        "itemType": "Item Type",
        "subType": "Sub Type",
        "weaponClass": "Weapon Class",
        "slot": "Slot",
        "size": "Size",
        "grade": "Grade",
        "hidden": "Hidden?",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      }
    }
  }
}
